import type { IconSvgObject } from './types';

const EarRings02Icon: IconSvgObject = [
  ["ellipse", { cx: "7", cy: "15.5", rx: "3", ry: "5.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["ellipse", { cx: "17", cy: "15.5", rx: "3", ry: "5.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 10V7C15.5 7 15 5.89877 15 5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5V6L20 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 10V7C5.5 7 5 5.89877 5 5C5 3.89543 5.89543 3 7 3C8.10457 3 9 3.89543 9 5V6L10 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M4 14L10 18", stroke: "currentColor", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M14 14L20 18", stroke: "currentColor", strokeWidth: "1.5", key: "5" }]
];

export default EarRings02Icon;
